module.exports = __webpack_public_path__ + "static/media/gift-card-active.0ec3da99.svg";